function PersistentJobsCtrl($scope,$state){

	// get account id filter from parameters - currently not in use
	$scope.accountId = parseInt($state.params.accountId);
	$scope.active = [];
	$scope.historical = [];
	$scope.tableDataModified = false;

	$scope.states = ["ERROR", "SUCCESS", "WARNING", "IN_PROGRESS", "SERVER_RESTART", "PAUSED"];

	var tableProperties = {
        titleSearch: 'Jobs',
        clientSideSort: true,
        clientSideSearch: true,
        clientSidePaging: true,
        pageSize: 10,
        sortList: [ {sortField: 'startTime', sortDir: 'DESC'},
                    {sortField: 'percent', sortDir: 'DESC'}],
        searchPredicate: function(item, valueToSearch) {
            return (item.jobId?.toLowerCase().includes(valueToSearch)) ||
                    (item.jobParams && Object.values(item.jobParams).some(x => x?.toLowerCase().indexOf(valueToSearch) >= 0));
        },
    }

    $scope.activeJobsTableConfig = {
        fields : [
            getStartTimeField(),
            getJobIdField(),
            {   label:'Paused',
                path:'isPaused',
                class: 'act-table-col-paused'
            },
            getParamsField(),
            getPercentField(),
            {
                label: 'Stages',
                template: getStagesTemplate(true),
                class: 'act-table-col-stages',
                noSort: true
            }
        ],
        parseData: function(data){
            if (!$scope.active || $scope.active.length === 0) {
                return null;
            }
            return $scope.active;
        },
    };

    $scope.historicalJobsTableConfig = {
        fields : [
            getStartTimeField(),
            getJobIdField(),
            getParamsField(),
            getPercentField(),
            {
                label: 'Stages',
                template: getStagesTemplate(false),
                noSort: true
            },
            {
                label: 'Unique Name',
                path: 'name',
                class: 'his-table-col-name'
            }
        ],
        parseData: function(data){
            if (!$scope.historical || $scope.historical.length === 0) {
                return null;
            }
            return $scope.historical;
        },
    };

    _.merge($scope.activeJobsTableConfig, tableProperties);
    _.merge($scope.historicalJobsTableConfig, tableProperties);

    function getPercentField() {
        return {    label:'Percent',
                    path:'percent',
                    template: "{{item.percent}}%",
                    class: 'per-table-col-number'
               }
    }
    function getParamsField() {
        return {    label:'Params',
                    template: '<table><tr ng-repeat="(paramName,paramValue) in item.jobParams"><td><b>{{paramName}}:</b></td><td>{{paramValue}}</td></tr></table>',
                    class: 'per-table-col-params',
                    noSort: true
                }
    }
    function getStartTimeField() {
        return {   label:'Start Time',
                    path: 'startTime',
                    template: "{{item.startTime | date : 'M/d/yy HH:mm:ss'}}",
                    class: 'per-table-col-time'
                }
    }
    function getJobIdField() {
        return {   label: 'ID',
                    path: 'jobId',
                    class: 'per-table-col-id'
                }
    }

    function getStagesTemplate(isActiveJob, stagesHistory) {
        var stagesTable =
            `<table class="historic-jobs-stages-table">
                <thead>
                <tr>
                    <th>Start Time (local)</th>
                    <th>End Time (local)</th>
                    <th>Messages</th>
                </tr>
                </thead>
                <tbody>`;
        if (isActiveJob) {
            stagesTable +=
            `   <tr>
                    <td class="single-cell"><b>Active</b></td>
                </tr>
                <tr style="background-color: {{item.currentStage.state | statesColoring}}">
                    <td>{{item.currentStage.startTime | date : 'M/d/yy HH:mm:ss'}}</td>
                    <td>{{item.currentStage.endTime | date : 'M/d/yy HH:mm:ss'}}</td>
                    <td>
                        <ul>
                            <li ng-repeat="comment in item.currentStage.comments">
                                <span>{{comment}}</span>
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td class="single-cell"><b>Previous</b></td>
                </tr>`;
        }
        stagesTable +=
                    `<tr ng-repeat="stage in item.stagesHistory track by $index" style="background-color: {{stage.state | statesColoring}}">
                    <td>{{stage.startTime | date : 'M/d/yy HH:mm:ss'}}</td>
                    <td>{{stage.endTime | date : 'M/d/yy HH:mm:ss'}}</td>
                    <td>
                        <ul>
                            <li ng-repeat="comment in stage.comments track by $index">
                                <span>{{comment}}</span>
                            </li>
                        </ul>
                    </td>
                </tr>
                </tbody>
            </table>`;
        return stagesTable;
    }

    function processHistoricalData(items) {
        items.forEach(function(item) {
            item.percent = item.persistentJobDetails.percent;
            item.jobParams = item.persistentJobDetails.jobParams;
            item.stagesHistory = item.persistentJobDetails.stagesHistory;
        });
        return items;
    }

	angular.element(document).ready( function (){
	    var url = ($scope.accountId) ? '/persistentJobsByAccount?accountId=' + $scope.accountId : '/allPersistentJobs';
       	store.fetch({
       		method : 'GET',
       		url : url,
       		success: function(data, status, headers, config) {
       			$scope.active = data[0];
                $scope.historical = processHistoricalData(data[1]);
                $scope.tableDataModified = new Date().getTime();
                $scope.$digest();
    		}
    	});
    });

}
